import { useQuery } from '@tanstack/react-query';
import * as api from '../../services/api';
import { parseTextToVisual } from '../../utils/expressionConverterBackend';
import type { ConfigurationData } from '../../types';

// Query hooks for validation and parsing
export const useValidateExpressionQuery = (expression: string, enabled = true) => {
  return useQuery({
    queryKey: ['validateExpression', expression],
    queryFn: () => api.validateConditionExpression({ expression }),
    enabled: enabled && !!expression.trim(),
    staleTime: 30 * 60 * 1000, // 30 minutes - expressions are deterministic and very cacheable
    retry: 1, // Don't retry validation failures extensively
  });
};

export const useParseExpressionQuery = (expression: string, enabled = true) => {
  return useQuery({
    queryKey: ['parseExpression', expression],
    queryFn: () => api.parseConditionExpression({ expression }),
    enabled: enabled && !!expression.trim(),
    staleTime: 30 * 60 * 1000, // 30 minutes - expressions are deterministic and very cacheable
    retry: 1,
  });
};

export const useParseTextToVisualQuery = (
  expression: string,
  config?: ConfigurationData | null,
  enabled = true
) => {
  return useQuery({
    queryKey: ['parseTextToVisual', expression, config?.lastUpdated ?? 'no-config'],
    queryFn: () => parseTextToVisual(expression, config),
    enabled: enabled && !!expression.trim(),
    staleTime: 30 * 60 * 1000, // 30 minutes - expressions are deterministic and very cacheable
    retry: 1,
  });
};
